import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgSelectModule } from "@ng-select/ng-select";
import { ModuleType } from "@enums/ModuleType";
import { MoiTypes } from "@enums/moi/MoiTypes";
import { MoiModel } from "@models/moi/MoiModel";
import { MoiPermissionModel } from "@models/moi/MoiPermissionModel";
import { provideTranslationScope, TranslatePipe } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/moi/i18n/scope";
import { CerrixTextfieldComponent } from "@app/shared/components/cerrix-textinput/cerrix-textfield/cerrix-textfield.component";
import { CerrixTextAreaComponent } from "@app/shared/components/cerrix-textinput/cerrix-textarea/cerrix-textarea.component";
import { CerrixSelectTreeComponent } from "@app/shared/cerrix-select-tree/cerrix-select-tree.component";
import { DateInputComponent } from "@app/shared/components/date-input/date-input.component";
import { CerrixUrlInputComponent } from "@app/shared/components/cerrix-url-input/cerrix-url-input.component";
import { MoiFindingReportSummaryComponent } from "./moi-finding-report-summary/moi-finding-report-summary.component";
import { ControlDetailOverviewComponent } from "@app/controls/detail-overview/control-detail-overview.component";
import { MoiEventSummaryComponent } from "./moi-event-summary/moi-event-summary.component";
import { MoiRiskSummaryComponent } from "./moi-risk-summary/moi-risk-summary.component";
import { MoiThirdPartySummaryComponent } from "./moi-thirdparty-summary/moi-thirdparty-summary.component";
import { MoiProcessingPurposeSummaryComponent } from "./moi-processing-purpose-summary/moi-processing-purpose-summary.component";
import { MoiIncidentSummaryComponent } from "./moi-incident-summary/moi-incident-summary.component";

@Component({
    selector: "moi-detail-main",
    templateUrl: "./moi-detail-main.component.html",
    styleUrls: ["./moi-detail-main.component.scss"],
    imports: [
        TranslatePipe,
        ReactiveFormsModule,
        MatTooltipModule,
        NgSelectModule,
        CerrixTextfieldComponent,
        CerrixTextAreaComponent,
        CerrixSelectTreeComponent,
        DateInputComponent,
        CerrixUrlInputComponent,
        MoiFindingReportSummaryComponent,
        ControlDetailOverviewComponent,
        MoiEventSummaryComponent,
        MoiRiskSummaryComponent,
        MoiThirdPartySummaryComponent,
        MoiProcessingPurposeSummaryComponent,
        MoiIncidentSummaryComponent,
    ],
    viewProviders: [provideTranslationScope(scope)],
})
export class MoiDetailMainComponent implements OnInit {
    @Output() workflowChanged = new EventEmitter<any>();

    @Input() moiModel: MoiModel;
    @Input() permissions: MoiPermissionModel;
    @Input() parentSummary: any;
    @Input() sd: any = {};
    @Input() parentForm: FormGroup;

    // Make enums useable in the front-end
    MoiTypes = MoiTypes;
    ModuleType = ModuleType.BIM;

    validReviewers: any[];
    validResponsibles: any[];
    validDelegates: any[];

    constructor() {}

    ngOnInit() {
        this.validReviewers = this.validUsers(
            this.moiModel.Reviewers,
            this.sd.Users,
            this.sd.Reviewers
        );
        this.validResponsibles = this.validUsers(
            this.moiModel.Responsibles,
            this.sd.Users,
            this.sd.Responsibles
        );
        this.validDelegates = this.validUsers(
            this.moiModel.Delegates,
            this.sd.Users,
            this.sd.Delegates
        );
    }

    validUsers(selectedUsers: number[], allUsers: any[], otherUsers): any[] {
        const result = otherUsers;
        for (let i = 0; i < allUsers.length; i++) {
            for (let j = 0; j < selectedUsers.length; j++) {
                if (!allUsers[i].Deleted && allUsers[i].Id === selectedUsers[j]) {
                    // user not deleted, but role no longer valid, insert ** in front
                    allUsers[i].Name = "** " + allUsers[i].Name;
                    result.push(allUsers[i]);
                    break;
                }
                if (allUsers[i].Deleted && allUsers[i].Id === selectedUsers[j]) {
                    // user deleted, insert * in front
                    allUsers[i].Name = "* " + allUsers[i].Name;
                    result.push(allUsers[i]);
                    break;
                }
            }
        }

        return result.distinct();
    }
}
